import { Icon, Tooltip } from '@scuf/common';
import React from 'react';
import './InfoTooltip.scss';

interface IInfoProps {
  content: string | JSX.Element;
  position?:
    | 'top left'
    | 'top right'
    | 'bottom right'
    | 'bottom left'
    | 'right center'
    | 'left center'
    | 'top center'
    | 'bottom center';
  color?: string;
  event?: 'click' | 'focus' | 'hover';
}

const InfoTooltip = (props: IInfoProps) => {
  const { content, position, color } = props;
  const icon = (
    <div className="icon-container" style={{ color: color ? color : '' }}>
      <Icon name="badge-info" root="common" />
    </div>
  );
  return (
    <Tooltip
      element={icon}
      content={content as string}
      position={position ? position : 'right center'}
      hideOnScroll={true}
      hoverable={false}
      event={props.event ? props.event : 'hover'}
    />
  );
};

export default InfoTooltip;
